module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queryBuilder"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('h4', [_vm._v("Select Data Source")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select a source"
    },
    on: {
      "change": _vm.onSourceChanged
    },
    model: {
      value: (_vm.query.source),
      callback: function($$v) {
        _vm.$set(_vm.query, "source", $$v)
      },
      expression: "query.source"
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('el-option', {
      key: source.value,
      attrs: {
        "label": source.label,
        "value": source.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "source content"
    },
    on: {
      "change": _vm.onContentChange
    },
    model: {
      value: (_vm.query.source_content),
      callback: function($$v) {
        _vm.$set(_vm.query, "source_content", $$v)
      },
      expression: "query.source_content"
    }
  }, _vm._l((_vm.contents), function(content) {
    return _c('el-option', {
      key: content.value,
      attrs: {
        "label": content.label,
        "value": content.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('h4', [_vm._v("Search Query")]), _vm._v(" "), _c('search-builder', {
    attrs: {
      "initialData": _vm.query.search
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "level sort"
  }, [_c('h4', [_vm._v("Sort")]), _vm._v(" "), _c('div', [_c('el-switch', {
    staticClass: "sortSwitch",
    attrs: {
      "on-color": "#13ce66",
      "on-text": "▽",
      "off-text": "△",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.query.sort.isAscending),
      callback: function($$v) {
        _vm.$set(_vm.query.sort, "isAscending", $$v)
      },
      expression: "query.sort.isAscending"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.query.sort.fields),
      callback: function($$v) {
        _vm.$set(_vm.query.sort, "fields", $$v)
      },
      expression: "query.sort.fields"
    }
  }, _vm._l((_vm.sortable_fields), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.query.sort.fields.length) ? _c('div', {
    staticClass: "generatedQuery"
  }, [_vm._v("\n      " + _vm._s(this.sortQuery) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level group"
  }, [_c('h4', [_vm._v("Group")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.query.groupBy),
      callback: function($$v) {
        _vm.$set(_vm.query, "groupBy", $$v)
      },
      expression: "query.groupBy"
    }
  }, _vm._l((_vm.groupable_fields), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['all fields', 'output fields'],
      "data": _vm.fields
    },
    model: {
      value: (_vm.query.selected_fields),
      callback: function($$v) {
        _vm.$set(_vm.query, "selected_fields", $$v)
      },
      expression: "query.selected_fields"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-query-container"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "initial"
    },
    attrs: {
      "placeholder": "query name"
    },
    model: {
      value: (_vm.query.name),
      callback: function($$v) {
        _vm.$set(_vm.query, "name", $$v)
      },
      expression: "query.name"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56298ad4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/queryBuilder/queryBuilder.vue
// module id = 230
// module chunks = 1